import { type InputType } from 'config'

import { LienType } from './interfaces'

export const scenarioInputs: Record<string, InputType> = {
  name: {
    title: 'What is your name?',
    inputType: 'text',
    key: 'name',
  },
  phone: {
    title: 'What is your phone number?',
    inputType: 'text',
    key: 'name',
    type: 'phone',
  },
  email: {
    title: 'What is your email address?',
    inputType: 'text',
    key: 'email',
    type: 'email',
    required: true,
  },
  ae: {
    title: 'Who are you currently working with?',
    inputType: 'select',
    options: {},
    hasDefaultOption: true,
    key: 'ae',
    required: true,
  },
}

export const termSheetFields = (): Record<string, InputType> => {
  return {
    LoanAmount: {
      title: 'Proposed Loan Amount',
      inputType: 'text',
      key: 'proposedLoanAmount',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    LTV: {
      title: 'LTV',
      inputType: 'text',
      type: 'number',
      error: '',
      prefix: '%',
      readOnly: true,
    },
    BorrowerName: {
      title: 'Borrower Name',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    BorrowerCompanyName: {
      title: 'Borrower Company Name',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    BrokerStreet: {
      title: 'Broker Street',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    BrokerCity: {
      title: 'Broker City',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    BrokerState: {
      title: 'Broker State',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    BrokerZipCode: {
      title: 'Broker ZipCode',
      inputType: 'text',
      type: 'number',
      error: '',
      readOnly: true,
    },
    LenderCompany: {
      title: 'Lender Company',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    SubjectPropertyAddress: {
      title: 'Subject Property Address',
      inputType: 'text',
      error: '',
      span: 2,
      readOnly: true,
    },
    InterestRate: {
      title: 'Interest Rate',
      inputType: 'text',
      type: 'number',
      error: '',
      readOnly: true,
    },
    LoanTerm: {
      title: 'Loan Term',
      inputType: 'text',
      type: 'number',
      error: '',
      readOnly: true,
    },
    DiscountFeePercent: {
      title: 'Discount Fee Percent',
      inputType: 'text',
      type: 'number',
      error: '',
      prefix: '%',
      readOnly: true,
    },
    DiscountFeeAmount: {
      title: 'Discount Fee',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    CashBorrowerAtClosing: {
      title: 'Cash Borrower At Closing',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    ExitFee: {
      title: 'Exit Fee',
      inputType: 'text',
      type: 'number',
      error: '',
      readOnly: true,
    },
    ConstructionBudget: {
      title: 'Construction Budget',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    ConstructionAmountFinanced: {
      title: 'Construction Amount Financed',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    BrokerFeeAmount: {
      title: 'Broker Fee',
      inputType: 'text',
      type: 'thousandSep',
      error: '',
      prefix: '$',
      required: true,
    },
    CommitmentFee: {
      title: 'Commitment Fee',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      required: true,
    },
    BreakUpFee: {
      title: 'Break-Up Fee',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
    },
    BrokerFeePercent: {
      title: 'Broker Fee Percent',
      inputType: 'text',
      type: 'number',
      error: '',
      prefix: '%',
      required: true,
    },
    BrokerCompanyName: {
      title: 'Broker Company Name',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    UnderwritingFee: {
      title: 'Underwriting Fee',
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      error: '',
      prefix: '$',
      readOnly: true,
    },
    BorrowerType: {
      title: 'Borrower Type',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    FiveLaterDate: {
      title: 'Five Later Date',
      inputType: 'text',
      type: 'date',
      error: '',
      readOnly: true,
    },
    TodayDate: {
      title: 'Today Date',
      inputType: 'text',
      type: 'date',
      error: '',
      readOnly: true,
    },
    LoanOfficerOrBrokerName: {
      title: 'Loan Officer | Broker Name',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    EstimatedCreditScore: {
      title: 'Credit Score',
      key: 'estimatedCreditScore',
      inputType: 'text',
      type: 'creditScore',
      error: '',
      readOnly: true,
    },
    DueDilligence: {
      title: 'Due Dilligence',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    MonthlyPaymentNonEscrow: {
      title: 'Monthly Payment (non escrow)',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    MonthlyPaymentWithEscrow: {
      title: 'Monthly Payment (with escrow)',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    PrepaymentPenalty: {
      title: 'Prepayment Penalty (months)',
      inputType: 'text',
      error: '',
      readOnly: true,
    },
    InitialLoanAmount: {
      title: 'Initial Loan Amount',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    PurchasePrice: {
      title: 'Purchase Price',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    DSCRValue: {
      title: 'DSCR Value',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      error: '',
      required: true,
    },
    LTC: {
      title: 'LTC',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      error: '',
      required: true,
    },
    LTARV: {
      title: 'LTARV',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      error: '',
      required: true,
    },
    MonthlyPaymentInitialNonDutch: {
      title: 'Monthly Payment (Initial Non Dutch)',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      error: '',
      required: true,
    },
    BorrowerEntityTitle: {
      title: 'Borrower Entity Title',
      inputType: 'text',
      error: '',
      required: true,
    },
    BorrowerPresentAddress: {
      title: 'Borrower Present Address',
      inputType: 'map',
      error: '',
      required: true,
    },
    AmortizationType: {
      title: 'Amortization Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['ARM', 'Fixed', 'IO - ARM', 'IO - Fixed'],
      error: '',
      required: true,
    },
  }
}

export const overrideFields = (): Record<string, InputType> => {
  return {
    override: {
      title: 'Override Interest Rate and Base Price?',
      inputType: 'check',
      error: '',
      required: true,
    },
    type: {
      inputType: 'InputWithButton',
      type: 'text',
      title: 'Product Type',
      value: '',
      required: true,
      modalTitle: 'Choose a Product Type',
      options: {},
      multiple: false,
      enableInput: true,
    },
    program: {
      inputType: 'InputWithButton',
      type: 'text',
      title: 'Program',
      value: '',
      required: true,
      modalTitle: 'Choose a Program',
      options: {},
      multiple: false,
      enableInput: true,
    },
    rate: {
      title: 'Interest Rate',
      type: 'number',
      inputType: 'text',
      required: true,
    },
    price: {
      title: 'Base Price',
      type: 'number',
      inputType: 'text',
      required: true,
    },
    lockDays: {
      title: 'Lock Days',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['15', '21', '30', '45', '60'],
      error: '',
      required: true,
    },
    rateSpread: {
      title: 'Rate Spread',
      type: 'number',
      inputType: 'text',
      required: true,
    },
    exitFee: {
      title: 'Exit Fee',
      type: 'number',
      inputType: 'text',
      required: true,
    },
    note: {
      title: 'Notes',
      inputType: 'textarea',
      rows: 3,
    },
  }
}

export const getDefaultLoanProcessData = () => {
  return {
    type: '',
    program: '',
    rate: 0,
    price: 0,
    sheetDate: '',
    lockDays: 0,
    lockedDate: '',
    rateLocked: false,
    pricingRequested: false,
    rateSpread: NaN,
    exitFee: NaN,
  }
}

export const historyLabels: any = {
  type: 'Type',
  program: 'Program',
  rate: 'Rate',
  price: 'Price',
  sheetDate: 'Sheet Date',
  lockDays: 'Lock Days',
  lockedDate: 'Locked Date',
  rateLocked: 'Rate Locked?',
  expireDate: 'Expire Date',
  extensions: 'Extensions',
  note: 'Note',
  override: 'Pricing Adjustment',
  rateSpread: 'Rate Spread',
  exitFee: 'Exit Fee',
}

export const hiddenHistoryKeys = ['brokerAdjustment', 'priceOption', 'pricingRequested', 'subProgramID']

export const convertHistoryLabel = (key: string) => {
  let rlt = historyLabels[key]
  if (!rlt) rlt = key
  return rlt
}

export const overrideValidationKeyOptions: any = {
  afterRepairValue: 'After Repair Value',
  asIsValue: 'As Is Appraised Value',
  constructionReserve: 'Construction Amount Financed',
  totalRehabFinancedPercent: 'Total Construction Financed',
  constructionFinancedHoldback: 'Construction Financed Holdback',
  atClosingBorrowerAmount: 'Estimated Closing Amount',
  estimatedCreditScore: 'Estimated Credit Score',
  propertyType: 'Property Type',
  proposedLoanAmount: 'Proposed Loan Amount',
  other: 'Other',
}

export const pendingChangeRequestTypes: Record<number, string> = {
  1: 'Loan Change Request',
  2: 'Exception Review Request',
  3: 'Loan Detail Override Request',
}

export const declineFields = (): Record<string, InputType> => {
  return {
    comment: {
      inputType: 'textarea',
      title: 'Comment',
      value: '',
    },
  }
}

export enum LoanCategory {
  ORIGIN,
  POOL,
}

export const excelLoanDetailOptions: Record<string, Record<string, any>> = {
  productType: {
    Bridge: 'Bridge',
    FNF: 'Fix and Flip',
    GUC: 'Ground Up Construction',
    DSCR: 'DSCR (Long Term Rental)',
  },
  lienType: {
    '1st': LienType.FIRST_LIEN,
    '2nd': LienType.SECOND_LIEN,
    '3rd': LienType.THIRD_LIEN,
  },
}
